import { Controller } from "@hotwired/stimulus"

// Shows/hides the partner and kids sections of the admin household form
// based on the party-policy checkboxes.
export default class extends Controller {
  static targets = ["partnerSection", "kidsSection"]

  connect() {
    this.sync()
  }

  sync() {
    const partner = this.element.querySelector("#household_partner_allowed")?.checked
    const kids = this.element.querySelector("#household_kids_allowed")?.checked
    this.partnerSectionTarget.classList.toggle("hidden", !partner)
    this.kidsSectionTarget.classList.toggle("hidden", !kids)
  }
}
